import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { MIN_PASSWORD_LENGTH } from "@/shared/lib/passwordRules";
import { FormField } from "@/shared/ui/form-field";
import { IconButton } from "@/shared/ui/icon-button";
import { Input } from "@/shared/ui/input";

type Props = {
  password: string;
  confirm: string;
  onPasswordChange: (v: string) => void;
  onConfirmChange: (v: string) => void;
  /** Mensagem de validação (exibida quando `showError`). */
  error?: string | null;
  showError?: boolean;
  autoFocus?: boolean;
};

/** Par "nova senha" + "confirmar senha" com regra de mínimo 6 caracteres (GUI). */
export function NewPasswordFields({
  password,
  confirm,
  onPasswordChange,
  onConfirmChange,
  error,
  showError,
  autoFocus,
}: Props) {
  const [visible, setVisible] = useState(false);
  const type = visible ? "text" : "password";
  const toggle = (
    <IconButton
      icon={visible ? EyeOff : Eye}
      label={visible ? "Ocultar senha" : "Mostrar senha"}
      size="sm"
      tooltip={false}
      onClick={() => setVisible((v) => !v)}
    />
  );
  const invalid = Boolean(showError && error);
  return (
    <div className="space-y-4">
      <FormField label="Nova senha" hint={`Mínimo de ${MIN_PASSWORD_LENGTH} caracteres.`}>
        <Input
          type={type}
          autoComplete="new-password"
          autoFocus={autoFocus}
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          invalid={invalid}
          trailing={toggle}
        />
      </FormField>
      <FormField label="Confirmar nova senha" error={invalid ? error : undefined}>
        <Input type={type} autoComplete="new-password" value={confirm} onChange={(e) => onConfirmChange(e.target.value)} />
      </FormField>
    </div>
  );
}
